import type { PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "services/api.ts";
import type { ConstantTypes } from "types/DataTypes";

interface SharedState {
  constants: ConstantTypes | null;
}

const initialState: SharedState = {
  constants: null,
};

const sharedSlice = createSlice({
  name: "shared",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchConstantsAndUpdateStore.fulfilled,
      (state, action: PayloadAction<ConstantTypes>) => {
        state.constants = action.payload;
      },
    );
  },
});

export const fetchConstantsAndUpdateStore = createAsyncThunk(
  "claim/fetchConstantsAndUpdateStore",
  async ({ accessToken }: { accessToken: string }, { dispatch }) => {
    const result = await dispatch(
      // @ts-expect-error passed through linting
      api.endpoints.getConstants.initiate({ accessToken }),
    );
    if ("data" in result) {
      return result.data;
    }
    throw new Error(
      `Failed to fetch constants. Check network error messages for more details`,
    );
  },
);

export default sharedSlice.reducer;
